import { instance } from "libs/api";

import { AiReviewListResponse, EAiReviewStatus } from "../../aiReview.types";
import { ApiRoutesAiReview } from "../../constants/enums";

export interface GetReviewItemsParams {
  status: EAiReviewStatus;
  page: number;
  take: number;
}

// V1: one tab of the list, with the counts of every tab and the sweep info.
export const requestGetReviewItems = async (
  params: GetReviewItemsParams
): Promise<AiReviewListResponse> =>
  await instance.get(ApiRoutesAiReview.Root, { params });
